export default __webpack_public_path__ + "95434c78dae7e5ed13870d29f2e7ca68.jpg";